import {Dialog} from 'vant';
import './index.styl'
window.$dialog = Dialog;
export default Dialog;
//使用方法　https://www.youzanyun.com/zanui/vant#/zh-CN/component/dialog



// WEBPACK FOOTER //
// ./src/components/Popups/Dialog/index.js